export function storyHtml(): string {
  return `
    <section class="site-story" aria-label="About Meetingly">
      <h2>Coordinate across time zones without the back-and-forth</h2>
      <p>Meetingly is a lightweight planner for remote teams, recruiters, freelancers, and anyone booking calls with people in other countries. No accounts. No spreadsheets. A private link, then a time that works.</p>

      <div class="story-grid">
        <article>
          <h3>See the overlap</h3>
          <p>Add cities or acronyms. A world map and a 24-hour grid show everyone’s local time, day and night included.</p>
        </article>
        <article>
          <h3>Share a private room</h3>
          <p>Send a secret link. Each person can sync Google Calendar or upload an .ics. Only busy/free is used — never meeting titles.</p>
        </article>
        <article>
          <h3>Pick and send</h3>
          <p>Choose a slot that works for everyone, then drop it into Google Calendar or Outlook.</p>
        </article>
      </div>

      <h2>How it works</h2>
      <ol class="story-steps">
        <li>Add participants or time zones.</li>
        <li>Create and share a scheduling room.</li>
        <li>Participants sync calendars or mark that they are in.</li>
        <li>Select a time that works for everyone.</li>
        <li>Add the meeting to Google Calendar or Outlook.</li>
      </ol>

      <h2>Who it is for</h2>
      <ul class="story-uses">
        <li><strong>Remote teams</strong> booking standups across EST, CET, and SGT.</li>
        <li><strong>Recruiters</strong> offering interview slots without timezone math.</li>
        <li><strong>Freelancers</strong> scheduling clients in other countries.</li>
        <li><strong>International clients</strong> who just need one link that makes sense.</li>
      </ul>

      <h2>FAQ</h2>
      <dl class="story-faq">
        <dt>Do I need an account?</dt>
        <dd>No. You can plan a meeting in the browser. A scheduling room is a temporary secret link.</dd>
        <dt>What calendar access do you request?</dt>
        <dd>Only Google’s busy/free scope (<code>calendar.freebusy</code>). Meeting titles, guests, and email are not requested. Outlook is a download/export link, not a login.</dd>
        <dt>What do you store?</dt>
        <dd>In a room: cities, time zones, optional display names, busy/free intervals, and the selected hour. Rooms expire after 24 hours, or 2 hours after a time is locked. We do not sell this data.</dd>
        <dt>When do rooms expire?</dt>
        <dd>Automatically after 24 hours, or 2 hours after a meeting time is chosen. The data is then deleted from the room.</dd>
        <dt>Which calendars work?</dt>
        <dd>Google Calendar (optional sign-in) and any calendar that can export an .ics file. You can also pick a time with no calendar at all.</dd>
      </dl>

      <p class="story-cta"><button class="btn-lime" data-act="start" type="button">Start coordinating a meeting</button></p>
    </section>
  `;
}
